import styled from '@emotion/styled';

export const Container = styled.div`
    margin-bottom: ${({ theme }) => theme.base.spacing[2]};
    padding: ${({ theme }) => theme.base.spacing[2]};
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    grid-gap: ${({ theme }) => theme.base.spacing[2]};
`;
